/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { NotificationMarkAsReadPathParams, NotificationMarkAsReadResponse } from '../types/NotificationMarkAsRead'

/**
 * POST /notifications/:notificationId/read
 * @see backend/nexus/modules/Campaign/Http/Controllers/NotificationController.php NotificationController::markAsRead
 */
export async function notificationMarkAsRead(
	notificationId: NotificationMarkAsReadPathParams['notificationId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<NotificationMarkAsReadResponse>> {
	return axiosInstance.post(`/notifications/${notificationId}/read`, undefined, config)
}
